import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetSmallFisheriesQuery,
  usePublicGetSmallFisheriesQuery,
  useGetSmallFisheriesDefaultsQuery,
  usePublicGetSmallFisheriesDefaultsQuery,
  useUpdateSmallFisheriesMutation
} from '../features/modules/smallFisheryApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting small fisheries data based on the current route.
 */
export const useContextAwareGetSmallFisheries = createContextAwareHook(
  useGetSmallFisheriesQuery,
  usePublicGetSmallFisheriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting small fisheries defaults based on the current route.
 */
export const useContextAwareGetSmallFisheriesDefaults = createContextAwareHook(
  useGetSmallFisheriesDefaultsQuery,
  usePublicGetSmallFisheriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateSmallFisheriesMutation
}; 